
export function removeDuplicatesAndEmptyStrings(permittedModuleNames: string[]): string[] {
    const uniqueModuleNames = new Set<string>([...permittedModuleNames]);
    uniqueModuleNames.delete("");
    uniqueModuleNames.delete(null);
    return [...uniqueModuleNames];
}